<template>
  <div>
    <div class="container payment main">
      <div class="content">
        <div class="p-header">
          <div style="font-size: 0.32rem">
            支付剩余时间 {{ minutes }}:{{ seconds }}
          </div>
          <div class="amount">
            ￥<span>{{ details.amount }}</span>
          </div>
          <div>{{ details.shopName }}-{{ details.orderId }}</div>
        </div>
        <!--<div class="order-info">-->
        <!--<ul class="list">-->
        <!--<li><span class="list-tit">单号</span><span class="list-con">{{details.orderId}}</span></li>-->
        <!--<li><span class="list-tit">客户</span><span class="list-con">{{details.consignee}}</span></li>-->
        <!--<li><span class="list-tit">应付</span><span class="list-amount ">￥ {{details.amount}}</span></li>-->
        <!--<li>-->
        <!--<span class="list-tit">送达</span><span class="list-time">{{details.deliveryDate}}</span><span class="list-time" v-if="details.deliveryTime==0">立即送达</span><span class="list-time" v-else>{{details.deliveryTime}}</span>-->
        <!--</li>-->
        <!--<li><span class="list-tit">详情</span><span @click='showGoodsList' :class="['list-arrow', {'on':isShowGoodsList==true}]"></span></li>-->
        <!--</ul>-->
        <!--</div>-->
        <!--<div class="goods-list" v-if="isShowGoodsList==true">-->
        <!--<ul>-->
        <!--<li v-for="item in details.goodsList">-->
        <!--<span class="fl goods-name">{{item.name}}</span>-->
        <!--<span class='fl'>x{{item.buyNum}}</span>-->
        <!--<span :class="['fr',{'red': item.originalGdAmount!= null && item.originalGdAmount!='' && item.originalGdAmount!=undefined}]" style="margin-left: 0.37rem">￥ {{item.gdAmount}}</span>-->
        <!--<span class="fr origin-price"><span v-if="item.originalGdAmount!=null">￥ </span>{{item.originalGdAmount}}</span>-->
        <!--</li>-->
        <!--</ul>-->
        <!--</div>-->
        <div class="p-card">
          <div class="payment-list">
            <ul class="list">
              <!--微信-->
              <li
                v-for="(item, index) in details.paywayList"
                :key="index"
                v-if="
                  client_type != '11' &&
                  (item.payway_id == 3 ||
                    item.payway_id == 5 ||
                    item.payway_id == 20 ||
                    item.payway_id == 41)
                "
                :style="{ backgroundImage: 'url(' + item.image + ')' }"
                @click="selected(item.payway_id)"
              >
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    height: 100%;
                    justify-content: center;
                  "
                >
                  <div class="pay_logo">{{ item.name }}</div>
                  <div v-if="item.recommendInfo" class="recommend-info-txt">
                    {{ item.recommendInfo }}
                  </div>
                  <div v-if="item.recommendInfoList" class="recommend-info-txt">
                    <span v-for="info in item.recommendInfoList"
                      >{{ info.recommendInfo }};</span
                    >
                  </div>
                </div>
                <span
                  v-if="item.payway_id == 20 && !cardSchoolIds.includes(schoolId)"
                  class="card-detail"
                  @click="cardDetail"
                  @touchmove.prevent
                  >详情</span
                >
                <div :class="['pay_icon', { on: item.selected }]"></div>
              </li>
              <!--云闪付-->
              <li
                v-for="item in details.paywayList"
                v-if="client_type == '11' && item.payway_id == 31"
                :style="{ backgroundImage: 'url(' + item.image + ')' }"
                @click="selected(item.payway_id)"
              >
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    height: 100%;
                    justify-content: center;
                  "
                >
                  <div class="pay_logo">{{ item.name }}</div>
                  <div v-if="item.recommendInfo" class="recommend-info-txt">
                    {{ item.recommendInfo }}
                  </div>
                  <div v-if="item.recommendInfoList" class="recommend-info-txt">
                    <span v-for="info in item.recommendInfoList"
                      >{{ info.recommendInfo }};</span
                    >
                  </div>
                </div>
                <div :class="['pay_icon', { on: item.selected == true }]"></div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="btn btn-white fixed fixed-bottom">
        <button
          :disabled="isDisabled"
          class="btn btn-yellow btn-confirm"
          @click="confirmPay"
        >
          立即支付
        </button>
      </div>
    </div>
    <!--校园卡授权弹窗-->
    <div
      class="mask over"
      v-if="isShowAuth"
      @click="isShowAuth = false"
      @touchmove.prevent
    ></div>
    <div class="alert-box" v-if="isShowAuth" @touchmove.prevent>
      <h2 class="tit">还未授权校园卡</h2>
      <div class="btn-yellow authBtn" @click="toAutn()" @touchmove.prevent>
        立即授权
      </div>
      <p class="des">为保证卡片安全会不定期重新授权</p>
      <div class="close-btn" @click="isShowAuth = false"></div>
    </div>
    <!--校园卡信息-->
    <div
      class="mask over"
      v-if="isShowCardInfo"
      @click="isShowCardInfo = false"
      @touchmove.prevent
    ></div>
    <div class="alert-box" v-if="isShowCardInfo" @touchmove.prevent>
      <h2 class="tit">校园卡信息</h2>
      <p class="des desInfo">卡号：{{ schoolCardCode }}</p>
      <div
        class="btn-yellow authBtn sureBtn"
        @click="isShowCardInfo = false"
        @touchmove.prevent
      >
        确定
      </div>
      <div class="close-btn" @click="isShowCardInfo = false"></div>
    </div>
    <!--浙江工商校园卡信息-->
    <div
      class="mask over"
      v-if="isShowCardInfo1"
      @click="isShowCardInfo1 = false"
      @touchmove.prevent
    ></div>
    <div
      class="alert-box school-card"
      v-if="isShowCardInfo1"
      @touchmove.prevent
    >
      <h2 class="tit">请输入账号{{paymentDetail.campusAuthType === 0 ? '和密码' : ''}}</h2>
      <div class="form">
        <div class="input">
          <span class="label">工号/学号：</span>
          <input
            type="text"
            placeholder="请输入工号/学号"
            v-model="schoolCard.accNum"
          />
        </div>
        <div class="input" v-if="paymentDetail.campusAuthType === 0 || paymentDetail.campusAuthType === 2">
          <span class="label">密码：</span>
          <input
            type="password"
            placeholder="请输入密码"
            v-model="schoolCard.password"
          />
        </div>
      </div>
      <div
        class="btn-yellow authBtn sureBtn"
        @click="submitSchoolCardForm()"
        @touchmove.prevent
      >
        去支付
      </div>
      <div class="close-btn" @click="isShowCardInfo1 = false"></div>
    </div>
  </div>
</template>
<!--<script src="https://code.jquery.com/jquery-3.4.1.slim.min.js"></script>-->
<!--<script src="https://open.95516.com/s/open/js/upsdk.js"></script>-->

<script>
import { actions } from "../store/actions";
// import { Indicator, MessageBox } from 'mint-ui'

export default {
  data() {
    return {
      details: "",
      timer: "",
      minutes: "",
      seconds: "",
      paymentType: 12,
      isShowGoodsList: true,
      canSubmit: true,
      pageShow: false,
      orderId: window.localStorage.getItem("orderCode"),
      isDisabled: false,
      client_type: localStorage.getItem("platformType"),
      url: "",
      title: "",
      redirectUrl: "",
      source: "",
      isShowAuth: false,
      isShowCardInfo: false,
      schoolCardCode: "",
      dlbWxAppletFlag: false,
      schoolId: "",
      cardSchoolIds: "",
      schoolCard: {
        accNum: "",
        password: "",
      },
      isShowCardInfo1: false,
      paymentDetail: {},

      orderType: localStorage.getItem("order-type"),
      returnBackUrl: localStorage.getItem("returnBack"),
    };
  },
  created() {
    // document.title = "在线支付"
    if (this.$route.params.reward) {
      this.title = "支付打赏";
      this.redirectUrl = "Reward";
    } else {
      this.title = "在线支付";
      this.redirectUrl = "OrderDetail";
      // 券包
      if (this.orderType && this.orderType == 8) {
        this.redirectUrl = "CouponPackageRecord";
      }
    }
    this.source = this.$utils.getCookie("source")
      ? this.$utils.getCookie("source")
      : null;
    this.getBeforePaymentInfo();
    // 云闪付支付
    if (this.$utils.isAndroid()) {
      this.url = window.localStorage.getItem("upSDKUrl");
    } else {
      this.url = window.location.href;
    }
    // 获取哆啦宝配置
    var _this = this;
    actions.getOrderPaywayStatus(_this, {}, (data) => {
      _this.dlbWxAppletFlag = data.dlbWxAppletFlag == 1 ? true : false;
      if (_this.$utils.isWxWork()) {
        // 企业微信
        _this.dlbWxAppletFlag = false;
      }
    });

    // 浙江工商 上海理工校园卡
    this.schoolId = JSON.parse(localStorage.getItem("schoolInfo")).schoolId;
    if (process.env.NODE_ENV == "production") {
      this.cardSchoolIds = [296,335];
    } else {
      this.cardSchoolIds = [1899,335];
    }
  },
  beforeRouteLeave(to, from, next) {
    window.clearInterval(this.timer);
    next();
  },
  methods: {
    Countdowns: function () {
      var _this = this;
      var SysSecond = parseFloat(_this.details.dateLineOfPayment) / 1000;
      _this.timer = window.setInterval(function () {
        if (SysSecond > 0) {
          SysSecond = SysSecond - 1;
          var minutes = Math.floor((SysSecond / 60) % 60); // 计算分
          var seconds = Math.floor(SysSecond % 60); // 计算秒

          // console.log(minutes,seconds)
          if (seconds < 10) {
            _this.seconds = "0" + seconds;
          } else {
            _this.seconds = seconds;
          }
          if (minutes < 10) {
            _this.minutes = "0" + minutes;
          } else {
            _this.minutes = minutes;
          }
          //            _this.pageShow = true
        } else {
          _this.canSubmit = false;
          window.clearInterval(_this.timer);
          _this.minutes = "00";
          _this.seconds = "00";
          _this.$messagebox.alert("支付超时", "");
        }
      }, 1000);
    },
    getBeforePaymentInfo: function () {
      var _this = this;
      var params = {
        order_id: _this.orderId,
        source: _this.source,
      };
      actions.getPayWay(
        _this,
        params,
        function (data) {
          _this.$indicator.close();
          for (let item of data.paywayList) {
            // item.selected = false
            if (item.payway_id == 3) {
              // item.selected = true
            }
            if (_this.client_type == "11" && item.payway_id == 31) {
              // item.selected = true
              _this.paymentType = 31;
            }
            if (item.selected) {
              if (item.payway_id === 3) {
                // 微信支付
                _this.paymentType = 12;
              } else if (item.payway_id === 5) {
                // 支付宝支付
                _this.paymentType = 52;
              } else if (item.payway_id === 31) {
                // 云闪付支付
                _this.paymentType = 31;
              } else if (item.payway_id === 20) {
                // 校园卡支付
                _this.paymentType = 20;
                if (_this.cardSchoolIds.includes(_this.schoolId)) {
                  _this.getSchoolCardInfo();
                }
              } else if (item.payway_id === 41) {
                // 数字人民币支付
                _this.paymentType = 41;
              }
              _this.paymentDetail = item;
            }
          }
          _this.details = data;
          _this.Countdowns();
          _this.isAuthSuc();
        },
        function () {
          _this.$indicator.close();
        }
      );
    },
    selected: function (id) {
      for (let v of this.details.paywayList) {
        if (v.payway_id === id) {
          v.selected = true;
          if (id === 3) {
            // 微信支付
            this.paymentType = 12;
          } else if (id === 5) {
            // 支付宝支付
            this.paymentType = 52;
          } else if (id === 31) {
            // 云闪付支付
            this.paymentType = 31;
          } else if (id === 20) {
            // 校园卡支付
            this.paymentType = 20;
            if (this.cardSchoolIds.includes(this.schoolId)) {
              this.getSchoolCardInfo();
            }
          } else if (id === 41) {
            // 数字人民币支付
            this.paymentType = 41;
          }
          this.paymentDetail = v;
        } else {
          v.selected = false;
        }
      }
    },
    // 校园卡信息
    getSchoolCardInfo() {
      let _this = this;
      actions.schoolCardInfo(
        _this,
        { school_id: _this.$store.state.schoolInfo.schoolId },
        function (data) {
          if (data && data.per_code) {
            _this.schoolCard.accNum = data.per_code;
          } else {
            _this.schoolCard.accNum = "";
          }
        }
      );
    },
    submitSchoolCardForm() {
      if (!this.schoolCard.accNum || this.schoolCard.accNum.length == 0) {
        this.$messagebox.alert("请输入一卡通账号", "");
        return;
      }
      if (this.paymentDetail.campusAuthType === 0 && (!this.schoolCard.password || this.schoolCard.password.length == 0)) {
        this.$messagebox.alert("请输入一卡通密码", "");
        return;
      }
      if (this.canSubmit) {
        this.H5pay();
      } else {
        this.$messagebox.alert("支付超时", "");
      }
    },
    showGoodsList: function () {
      if (this.isShowGoodsList) {
        this.isShowGoodsList = false;
      } else {
        this.isShowGoodsList = true;
      }
    },
    confirmPay: function () {
      if (this.canSubmit) {
        this.H5pay();
      } else {
        this.$messagebox.alert("支付超时", "");
      }
    },
    H5pay: function () {
      var _this = this;
      var params = {
        order_id: _this.orderId,
        payType: _this.paymentType,
        openid: _this.$store.state.openId, // 微信需要
        returnUrl: encodeURIComponent(this.url), // 云闪付需要
      };
      if (_this.paymentType === 52) {
        params.returnUrl = encodeURIComponent(
          _this.$utils.getHost() + "/orderdetail"
        );
        // 券包
        if (_this.orderType && _this.orderType == 8) {
          params.returnUrl = encodeURIComponent(
            _this.$utils.getHost() + "/couponPackage/list"
          );
        }
      }
      if (_this.paymentType === 12) {
        if (this.$utils.isWeiXin()) {
          params.payType = _this.dlbWxAppletFlag ? 21 : 9;
        }
        // 企业微信
        if (this.$utils.isWxWork()) {
          params.payType = 12;
        }
      }
      if (_this.paymentType === 41) {
        params.payType = 41;
        params.returnUrl = encodeURIComponent(
          _this.$utils.getHost() + "/orderdetail"
        );
        // 券包
        if (_this.orderType && _this.orderType == 8) {
          params.returnUrl = encodeURIComponent(
            _this.$utils.getHost() + "/couponPackage/list"
          );
        }
      }
      // 浙江工商 校园卡
      if (_this.paymentType === 20) {
        if (_this.cardSchoolIds.includes(_this.schoolId)) {
          if (!_this.isShowCardInfo1) {
            _this.isShowCardInfo1 = true;
            return;
          } else {
            params.zyOrderInfo = {
              accNum: _this.schoolCard.accNum
            };
            if(_this.paymentDetail.campusAuthType === 0){
              params.zyOrderInfo.password = _this.$utils.Encrypt(_this.schoolCard.password);
            }
          }
        }
      }
      _this.isDisabled = true;
      actions.postWxJsPay(
        _this,
        params,
        function (data) {
          // 微信
          if (_this.paymentType === 12) {
            if (_this.$utils.isWeiXin()) {
              // 判断是否微信浏览器中打开
              // 开始调起微信支付
              if (typeof WeixinJSBridge === "undefined") {
                if (document.addEventListener) {
                  document.addEventListener(
                    "WeixinJSBridgeReady",
                    _this.wxpay(data),
                    false
                  );
                } else if (document.attachEvent) {
                  document.attachEvent(
                    "WeixinJSBridgeReady",
                    _this.wxpay(data)
                  );
                  document.attachEvent(
                    "onWeixinJSBridgeReady",
                    _this.wxpay(data)
                  );
                }
              } else {
                _this.wxpay(data);
              }
            } else {
              _this.isDisabled = false;
              let url =
                data.mwebUrl +
                "&redirect_url=" +
                encodeURIComponent(_this.$utils.getHost() + "/orderdetail");
              // 券包
              if (_this.orderType && _this.orderType == 8) {
                url =
                  data.mwebUrl +
                  "&redirect_url=" +
                  encodeURIComponent(
                    _this.$utils.getHost() + "/couponPackage/list"
                  );
              }
              location.href = url;
            }
            // 企业微信
            if (_this.$utils.isWxWork()) {
              _this.isDisabled = false;
              let url =
                data.mwebUrl +
                "&redirect_url=" +
                encodeURIComponent(_this.$utils.getHost() + "/orderdetail");
              // 券包
              if (_this.orderType && _this.orderType == 8) {
                url =
                  data.mwebUrl +
                  "&redirect_url=" +
                  encodeURIComponent(
                    _this.$utils.getHost() + "/couponPackage/list"
                  );
              }
              location.href = url;
            }
          }
          // 支付宝
          if (_this.paymentType === 52) {
            if (_this.$utils.isWeiXin()) {
              // 判断是否微信浏览器中打开
              _this.$router.replace({
                name: "alipay",
                query: {
                  oid: _this.orderId,
                  t: window.localStorage.getItem("wxToken"),
                },
              });
            } else {
              const div = document.createElement("div");
              div.innerHTML = data.body;
              document.body.appendChild(div);
              document.forms[0].submit();
            }
            _this.isDisabled = false;
          }
          // 云闪付
          if (_this.paymentType === 31) {
            if (!_this.$utils.isWeiXin()) {
              // 判断是否微信浏览器中打开
              // console.log(data,'data')
              upsdk.config({
                appId: data.appId, // 必填，接入方的唯一标识，由云闪付分配
                timestamp: data.timestamp, // 必填，生成签名的时间戳，从1970年1月1日00:00:00至今的秒数，取东八区的北京时间，例1556096162
                nonceStr: data.nonceStr, // 必填，生成签名的随机串，参见附录三生成签名随机字符串
                signature: data.signature, // 必填，生成签名的摘要，参见附录一、附录二
                debug: false, // 开发阶段可打开此标记，云闪付APP会将调试信息toast出来
              });
              upsdk.error(function (err) {
                console.log(err);
              });
              upsdk.ready(function () {
                // config信息验证后会执行ready方法
                upsdk.pay({
                  tn: data.tn,
                  success: function () {
                    _this.isDisabled = false;
                    // 支付成功，开发者执行后续操作
                    // localStorage.setItem('paySource','upsdk')
                    // _this.$router.replace({name: _this.redirectUrl})
                    _this.$router.replace({
                      name: "PaySuccess1",
                      query: { orderId: _this.orderId },
                    });
                  },
                  fail: function (err) {
                    _this.isDisabled = false;
                    // 支付失败，err.msg 是失败原因描述，比如TN号不合法，或者用户取消了交易等等
                    _this.$messagebox.alert(err.msg, "");
                    _this.$router.replace({ name: _this.redirectUrl });
                  },
                });
              });
            }
          }
          // 上师大校园卡
          if (_this.paymentType === 20) {
            if (_this.cardSchoolIds.indexOf(_this.schoolId) > 0) {
              _this.isShowCardInfo1 = false;
            }
            _this.$router.replace({
              path: "schoolPaySuc",
              query: {
                payAmount: _this.details.amount,
                redirectUrl: _this.redirectUrl,
              },
            });
            _this.isDisabled = false;
          }
          // 数字人民币
          if (_this.paymentType === 41 && data.status == 1) {
            window.location.href = data.payUrl;
            _this.isDisabled = false;
          }
        },
        function (response) {
          // 响应错误回调
          _this.isDisabled = false;
          if (response.data.flag === -100) {
            if (_this.source === "shu") {
              //上海大学
              _this.$messagebox.alert("当前账号未开通校园卡消费功能");
            } else {
              //上海师范大学
              _this.isShowAuth = true;
            }
          } else {
            if (response.data.message) {
              _this.$messagebox.alert(response.data.message, "");
            }
          }
        }
      );
    },
    // 微信支付
    wxpay: function (redata) {
      var _this = this;
      var u = window.location.href.split("#")[0];
      actions.getJslbsConf(_this, u, function (data) {
        var wxappid = JSON.parse(data).appId;
        _this.$indicator.close();
        _this.onBridgeReady(wxappid, redata);
      });
    },
    onBridgeReady: function (wxappid, redata) {
      let _this = this;
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: wxappid, // 公众号名称，由商户传入
          timeStamp: redata.timeStamp, // 时间戳，自1970年以来的秒数
          nonceStr: redata.rndStr, // 随机串
          package: redata.xpackage,
          signType: redata.signType
            ? redata.signType
            : _this.dlbWxAppletFlag
            ? "RSA"
            : "MD5", // 微信签名方式：
          paySign: redata.sign, // 微信签名
        },
        function (res) {
          _this.isDisabled = false;
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            // localStorage.setItem('paySource','weixin')
            _this.$router.replace({
              name: "PaySuccess1",
              query: { orderId: _this.orderId },
            });
          } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
            _this
              .$messagebox({
                title: "支付失败",
                message: "您取消了微信支付",
                confirmButtonText: "确认",
              })
              .then((action) => {
                _this.$router.replace({ name: _this.redirectUrl });
              });
          } else {
            _this.$messagebox.alert(JSON.stringify(res), "");
            _this.$router.replace({ name: _this.redirectUrl });
          }
        }
      );
    },
    // 校园卡授权
    toAutn() {
      let host = "";
      if (process.env.NODE_ENV === "local") {
        host = "http://user-base.imcoming.com";
      } else if (process.env.NODE_ENV === "development") {
        host = "http://user-base.imcoming.com.cn";
      } else if (process.env.NODE_ENV === "test") {
        host = "http://user-base.imcoming.com";
      } else {
        host = "https://user-base.anlaiye.com";
      }
      let token = this.$store.state.wxLoginToken;
      let schoolId = this.$store.state.schoolInfo.schoolId;
      window.location.href =
        host +
        "/priv/campusCard/auth?school_id=" +
        schoolId +
        "&login_token=" +
        token +
        "&order_id=" +
        this.orderId;
    },
    // 判断是否授权成功
    isAuthSuc() {
      if (this.source === "shnu" || this.source === "shnun") {
        // shnu为上师大标识
        if (this.$utils.resolveUrl().status == 0) {
          for (let v of this.details.paywayList) {
            if (v.payway_id === 20) {
              v.selected = true;
              this.paymentType = 20;
            } else {
              v.selected = false;
            }
          }
          this.isShowAuth = false;
          this.$toast("授权成功");
        } else if (this.$utils.resolveUrl().status < 0) {
          this.isShowAuth = false;
          this.$toast("授权失败");
        }
      }
    },
    // 校园卡详情
    cardDetail() {
      let _this = this;
      let params = {
        login_token: _this.$store.state.wxLoginToken,
        school_id: _this.$store.state.schoolInfo.schoolId,
      };
      actions.schoolCardInfo(
        _this,
        params,
        function (data) {
          if (data && data.card_no) {
            _this.isShowCardInfo = true;
            _this.schoolCardCode = data.card_no;
          } else {
            //未授权
            if (_this.source === "shu") {
              //上海大学
              _this.$messagebox.alert("当前账号未开通校园卡消费功能");
            } else {
              //上海师范大学
              _this.isShowAuth = true;
            }
          }
        },
        function () {}
      );
    },
  },
};
</script>
<style scoped>
.payment .main,
.payment .content {
  padding: 0;
}
.payment .p-header {
  height: 5.8rem;
  margin-top: -0.4rem;
  padding-top: 1rem;
  background: #fed600;
  border-radius: 50%/0.4rem;
  text-align: center;
  font-size: 0.26rem;
}
.payment .p-header .amount {
  font-size: 0.64rem;
  font-weight: bold;
  padding: 0.2rem 0 0.1rem;
}
.payment .p-header .amount span {
  font-size: 0.8rem;
}
.payment .p-card {
  background: #ffffff;
  border-radius: 0.2rem;
  margin: -2.4rem 0.32rem 0 0.32rem;
}
.payment .payment-list {
  background: transparent;
}
.payment .payment-list li {
  padding: 0;
  margin: 0 0.32rem;
  height: 1.28rem;
  /* line-height: 1.28rem; */
  line-height: 0.36rem;
  background-size: 0.64rem 0.64rem;
  background-position: 0 center;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.payment .payment-list .pay_logo {
  padding-left: 0.9rem;
  font-size: 0.32rem;
}
.payment .payment-list .pay_icon{
  width: .4rem;
}
.payment .payment-list .pay_icon.on {
  background-size: 0.4rem 0.4rem;
}
.payment .btn-confirm{
  font-size: .34rem;
  font-weight: bold;
  background: #FFDF00;
  border-radius: .08rem;
}

button:after {
  border: none;
  outline: none;
}
.tit {
  font-size: 0.42rem;
  font-weight: normal;
  color: #2f2f2f;
  margin-top: 0.9rem;
  margin-bottom: 0.28rem;
}
.close-btn {
  background: url(../assets/images/close-icon-pay.png) no-repeat;
  background-size: 100%;
  width: 0.21rem;
  height: 0.21rem;
  position: absolute;
  top: 0.44rem;
  right: 0.44rem;
}
.authBtn {
  background: #ffdf00;
  border-radius: 0.5rem;
  width: 4.41rem;
  height: 0.9rem;
  line-height: 0.9rem;
  text-align: center;
  font-size: 0.28rem;
  color: #2f2f2f;
  margin: 0.5rem auto 0.28rem;
}
.sureBtn {
  margin: 0.6rem auto 0.63rem;
}
.des {
  color: #4a4a4a;
  font-size: 0.26rem;
  margin-bottom: 0.86rem;
}
.desInfo {
  margin-bottom: 0;
}
.card-detail {
  width: 0.72rem;
  height: 0.32rem;
  line-height: 0.32rem;
  text-align: center;
  background: #f5f5f5;
  border-radius: 0.16rem;
  font-size: 0.24rem;
  color: #2f2f2f;
  margin-left: 0.32rem;
  display: inline-block;
}
.recommend-info-txt {
  /* position: absolute; */
  font-size: 0.2rem;
  /* width: 100%; */
  color: #f90d0d;
  /* line-height: 0.4rem; */
  /* height: 0.36rem; */
  /* bottom: 0; */
  /* left: 0; */
  /* width: 100%; */
  padding: 0 0.9rem 0 0.9rem;
  /* overflow: hidden; */
  text-overflow: ellipsis;
  white-space: nowrap;
}
.alert-box.school-card {
  width: 80%;
}
.alert-box.school-card .tit {
  font-size: 0.32rem;
}
.alert-box.school-card .form .input {
  padding-top: 0.24rem;
}
.alert-box.school-card .form .input .label {
  display: inline-block;
  font-size: 0.28rem;
  width: 1.6rem;
}
.alert-box.school-card .form .input input {
  padding: 0.16rem;
  border: 1px solid #ddd;
  font-size: 0.28rem;
}
</style>



// WEBPACK FOOTER //
// Payment.vue?07ab067c